const MenuItem = ({ href, label, id }) => {
  return (
    <a
      className={`title title__bold title__small item-link `}
      href={href}
      target='_self'>
      {label}
    </a>
  );
};

export default MenuItem;
